module.exports = {
    licence:{
        Robot_problem_solved:'役に立った',
        Robot_problem_unsolved:'役に立たなかった',
        Robot_emptyMassege_reminder:"空のメッセージは送信できません",
        Robot_massege_ViewMore:'詳細を表示',
        Robot_massege_ViewLess:'縮小表示',
        Robot_greetings_1:"本日はどういうご用件でしょうか？",
        Robot_greetings_2:'他のものをお探しですか？キーワードを入力してください。詳しい情報があるか確認します！',
        Robot_closing_1_1:'ああ、ごめんねー。',
        Robot_closing_1_2:"まだ勉強中なんです。他のキーワードを試すか、",
        Robot_closing_1_login_1:'あーあ、ごめんねー。まだまだ勉強中です。',
        Robot_closing_1_login_2:'他のキーワードで試してみてください',
        Robot_closing_2:'こちら ',
        Robot_closing_3:'をクリックしてサポートチームにお問い合わせください。できるだけ早く返答いたします！',
        Robot_problem_unsolved_reply:'申し訳ございませんが、今回はこれ以上のことはできませんでした。今後のサポートを改善するために、お客様のリクエストを記録いたしました！こちらをクリックしてサポートチームにお問い合わせください。できるだけ早く返答いたします！',
        Robot_TypeHere:'ここに入力してください',
        Robot_greetings_label1:'データを新しいアプリにマージします',
        Robot_greetings_label2:'移行後のデータ損失',
        Robot_greetings_label3:'移行後、スケールは切断されます',
        Robot_greetings_label4:'移行後のヒント',
        Robot_greetings_label5:'カードに表示されているグラフィックス',
        Robot_greetings_label6:'体重履歴を表示',
        Robot_greetings_label7:'周囲履歴を表示',
        Robot_greetings_label8:'ヘルプはどこで受けられますか',
        Robot_greetings_label9:'その他',
        key_internet_error:'ネットワークで問題が発生しました。ネットワークの設定を確認してください。',
        Robot_title_Beta:'チャットボット',
        Robot_greetings_label1_login:'パスワードを忘れた場合',
        Robot_greetings_label2_login:'パスワードのリセット方法',
        Robot_greetings_label3_login:'データを新しいアプリにマージします',
        Robot_greetings_label4_login:'アプリが2つあるのはなぜですか',
        Robot_greetings_label5_login:'アカウントログインに関する注意事項',
        Robot_greetings_label6_login:"新しいアプリでは新規登録する必要がありますか",
        Robot_greetings_label7_login:"両方のアプリにアカウントがある場合はどうすればいいですか",
        Robot_greetings_label8_login:'ヘルプはどこで受けられますか',
        Robot_greetings_label9_login:'その他',
        Robot_greetings_label1_devicePage:'デバイスの追加方法',
        Robot_greetings_label2_devicePage:'「デバイスを追加のポップアップ」でデバイスを追加',
        Robot_greetings_label3_devicePage:'デバイスを手動で追加',
        Robot_greetings_label4_devicePage:'WiFiやBluetooth対応スケールのペアリングに関するヒント',
        Robot_greetings_label5_devicePage:'WiFiとのペアリング方法',
        Robot_greetings_label6_devicePage:"デバイスが「ペアリング済みデバイス」に表示されません",
        Robot_greetings_label7_devicePage:"デバイスを削除",
        Robot_greetings_label8_devicePage:'ヘルプはどこで受けられますか',
        Robot_greetings_label9_devicePage:'その他',
        Robot_greetings_label1_mePage:'プライマリユーザーを変更できますか',
        Robot_greetings_label2_mePage:'プライマリユーザー情報の編集方法',
        Robot_greetings_label3_mePage:'友人のデータを表示します',
        Robot_greetings_label4_mePage:'友達を追加',
        Robot_greetings_label5_mePage:'友達リクエストの送信方法',
        Robot_greetings_label6_mePage:"友達リクエストの確認方法",
        Robot_greetings_label7_mePage:"友達を削除",
        Robot_greetings_label8_mePage:'ヘルプはどこで受けられますか',
        Robot_greetings_label9_mePage:'その他',
        Robot_greetings_label1_balancePage:'体重データがAPPに同期されない',
        Robot_greetings_label2_balancePage:'Bluetoothエラーの確認方法',
        Robot_greetings_label3_balancePage:'アプリには体重とBMIしか表示されません',
        Robot_greetings_label4_balancePage:'筋肉の読み取り値が"--"で表示されます',
        Robot_greetings_label5_balancePage:'スケールの計測値が正しくありません',
        Robot_greetings_label6_balancePage:"体脂肪率の読み取り値が大きく変化します",
        Robot_greetings_label7_balancePage:"体重データを手動で入力",
        Robot_greetings_label8_balancePage:'別の測定ユーザーに切り替えます',
        Robot_greetings_label9_balancePage:'その他',
        Robot_greetings_label1_tapPage:'巻き尺の使用方法',
        Robot_greetings_label2_tapPage:'測定するユーザーを切り替える',
        Robot_greetings_label3_tapPage:'周囲のトレンドグラフを表示',
        Robot_greetings_label4_tapPage:'周囲履歴を表示',
        Robot_greetings_label5_tapPage:'周囲データを手動で入力',
        Robot_greetings_label6_tapPage:"ヘルプはどこで受けられますか",
        Robot_greetings_label7_tapPage:"その他",
        savetoAlbum: "アルバムに保存しました",
        key_cancel: 'キャンセル',
        key_confirm: '確定',
        key_deleted: '正常に削除されました',
        key_delete_popup: '履歴は削除すると復元できません。削除してもよいか確認してください。',
        key_delete_history: 'チャット履歴を削除',
        key_delete_confirmation: '削除の確認'
    }
}